// loading.service.ts
import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, delay, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  // Stato interno reattivo del loading
  private readonly _loading$ = new BehaviorSubject<boolean>(false);

  // Stream pubblico (readonly)
  readonly loading$: Observable<boolean> = this._loading$.pipe(delay(0));

  // Contatore (serve se hai più richieste contemporanee)
  private loadingCount = 0;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.show();
      }
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) this.hide();
    });
  }

  show(): void {
    this.loadingCount++;
    if (this.loadingCount === 1) {
      this._loading$.next(true);
    }
  }

  hide(): void {
    this.loadingCount--;
    if (this.loadingCount === 0) {
      this._loading$.next(false);
    }
  }

  reset(): void {
    this.loadingCount = 0;
    console.log('reset', this.loadingCount);
    this._loading$.next(false);
  }
}
